export default __webpack_public_path__ + "static/media/ftp-hover.01d91951.svg";